import { BlogState } from './store/blog/blog.state';
import { SharedModule } from './shared/shared.module';
import { ServiciosState } from './store/servicios/servicios.state';
import { IconService } from './services/utility/icon.service';
import { StaffState } from './store/staff/staff.state';
import { ShareService } from './services/utility/sharer.service';
import { InstitucionModule } from './services/institucion/institucion.module';
import { RedIApiModule } from './services/rediapi/redi-api.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { GlobalState } from './store/global/global.state';
import { ThemingService } from './services/utility/theming.service';
import { UpdateService } from './services/utility/updateVersion.service';
import { GlobalesComponentsModule } from './components/globales/globales.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MaterialModule } from './shared/material.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpApiInterceptor } from './utilitarios/interceptor';
import { SnackService } from './services/utility/snacks.service';
import { GoogleTagManagerModule } from "angular-google-tag-manager";
import * as gtagDominios from './utilitarios/dominios-gtagm';
import * as metaPixelDominios from './utilitarios/dominios-meta-pixel';
import { IntegrationsState } from './store/integrations/integrations.state';
import { PixelModule } from 'ngx-pixel';
import { SearchState } from './store/search/search.state';
import { TagsService } from './services/tags/tags.service';

// declare var gtagCode;

function setGtagCode(): string {
  let rutaInstitucion = window.location.host.toString();
  return gtagDominios.mapGtag.get(rutaInstitucion) || null;
}
function setMetaPixelCode(): string {
  let rutaInstitucion = window.location.host.toString();
  return metaPixelDominios.mapMetaPixel.get(rutaInstitucion) || null;
}
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    GlobalesComponentsModule,
    RedIApiModule,
    InstitucionModule,
    AppRoutingModule,
    MaterialModule,
    SharedModule,
    BrowserAnimationsModule,
    NgxsStoragePluginModule.forRoot({
      key: [GlobalState, StaffState]
    }),
    GoogleTagManagerModule.forRoot({
      id: setGtagCode(),
    }),
    PixelModule.forRoot({ 
      enabled: environment.trackPixel, 
      pixelId: setMetaPixelCode() 
    }),
    NgxsFormPluginModule.forRoot(),
    NgxsModule.forRoot([GlobalState,StaffState,ServiciosState,BlogState,IntegrationsState,SearchState], {
      developmentMode: !environment.production,
    }),
    NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
    FontAwesomeModule,
  ],
  providers: [
    UpdateService,
    ThemingService,
    ShareService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpApiInterceptor,
      multi: true,
    },
    IconService,
    SnackService,
    TagsService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
